


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter, mdbBtn, mdbIcon } from '@folky-tools/mdbvue';
import { pwaInstallState, promptPwaInstall } from '@/plugins/pwa-install';

@Component({
    components: {
        mdbModal,
        mdbModalHeader,
        mdbModalBody,
        mdbModalFooter,
        mdbBtn,
        mdbIcon
    }
})
export default class SuggestPwaInstall extends Vue {

    // The deferred prompt is captured by App.vue, which is mounted long before this component.
    private get installPWABtnVisible(): boolean {
        return pwaInstallState.deferredPrompt !== null;
    }
    private $deviceSniffing: any;
    private pwaInstallSuggestionVisible: boolean = false;
    private isDeviceMobileOrTablet: boolean = false;
    private isVisitFromPWA: boolean = false;
    private pwaInstallDismissed: boolean = false;
    private browserInfo: any = { browserInfo: undefined, platform: undefined };

    // Opens the sheet on demand, ignoring both the dismissal and the device checks that gate the
    // automatic suggestion. Callers here are explicit user requests to install, so there is nothing
    // to second-guess: on a desktop with no deferred prompt the sheet still explains what to do.
    public open(): void {
        this.pwaInstallSuggestionVisible = true;
    }

    private closePWAInstallSuggestionSheet(): void {
        this.pwaInstallSuggestionVisible = false;
        this.pwaInstallDismissed = true;
    }

    private async installPWA(): Promise<void> {
        if (await promptPwaInstall()) {
            this.closePWAInstallSuggestionSheet();
        }
    }

    private mounted(): void {
        this.browserInfo = this.$deviceSniffing.getBrowserInfo();
        this.isVisitFromPWA = this.$deviceSniffing.isDisplayMode('standalone');
        this.isDeviceMobileOrTablet = this.$deviceSniffing.isDeviceMobileOrTablet();
        setTimeout(() => {
            const isAppleDevice = this.browserInfo.platform === 'iphone' || this.browserInfo.platform === 'ipad';
            // Only ever opens. It used to assign the condition straight to the flag, which closed a sheet that
            // had already been opened on purpose -- on a desktop the condition is false and it would slam shut.
            if (this.isDeviceMobileOrTablet && !this.isVisitFromPWA && !this.pwaInstallDismissed && (isAppleDevice || this.installPWABtnVisible)) {
                this.pwaInstallSuggestionVisible = true;
            }
        }, 2500);
    }
}
